import styled from "styled-components";

import StyledCheckbox from "./StyledCheckbox.styled";

const CheckboxLabel = styled.label`
  display: flex;
  align-items: flex-start;
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);

  ${StyledCheckbox} {
    margin-right: 16px;
  }
`;

export default CheckboxLabel;
